<div *ngIf="!blockButton">
  <div *ngIf="menuitems.length > 1">
    <button pButton size="medium" severity="primary" (click)="menuAdd.toggle($event)" [aria-label]="add_label || 'Add Item'" [disabled]="disabled">
      <span *ngIf="use_icon" [pTooltip]="add_label">
        <i class="fas fa-plus"></i>
      </span>
      <span *ngIf="!use_icon">{{add_label || 'add_item'| translation}}</span>
    </button>
    <p-menu #menuAdd [model]="menuitems" [popup]="true" [appendTo]="'body'"></p-menu>
  </div>
  <div *ngIf="menuitems.length === 1">
    <button pButton size="medium" severity="contrast" pTooltip="{{'add'|translation}} {{menuitems[0].title}}" aria-label="Add Item" (click)="addItem(menuitems[0])" [disabled]="disabled">
      <span *ngIf="use_icon" title="{{menuitems[0].title || add_label}}">
        <i class="fas fa-plus"></i>
      </span>
      <span *ngIf="!use_icon">{{menuitems[0].title || add_label}}</span>
    </button>
  </div>
</div>
<div class="scaffold-create-button" *ngIf="blockButton">
  <div *ngIf="menuitems.length > 1">
    <p-button severity="link" variant="text" size="large" (click)="menu.toggle($event)" [disabled]="disabled">
      <span *ngIf="use_icon" class="create-button-icon">
        <i class="fas fa-plus"></i>
      </span>
      <span class="create-button-heading">{{add_label}}</span>
    </p-button>
    <p-menu #menu [model]="menuitems" [popup]="true" [appendTo]="'body'"></p-menu>
  </div>
  <div *ngIf="menuitems.length === 1">
    <p-button severity="link" variant="text" size="large" (click)="addItem(menuitems[0])" [disabled]="disabled">
      <span *ngIf="use_icon" class="create-button-icon">
        <i class="fas fa-plus"></i>
      </span>
      <span class="create-button-heading">{{add_label}}</span>
    </p-button>
  </div>
</div>
